export default __webpack_public_path__ + "static/media/overwhelm6.aeee85d7.png";